module.exports = __webpack_public_path__ + "static/img/risk-icon3.9b9c0a0a.png";